import React from 'react';
import { Shield, ShieldAlert, Wifi, WifiOff, FolderGit2, Cpu } from 'lucide-react';
import { TunnelStatus } from '../types';

interface NavbarProps {
  status: TunnelStatus | null;
  onSetMode: (mode: 'WORK' | 'FULL') => void;
  onSetWorkspace: (path: string) => void;
}

export const Navbar: React.FC<NavbarProps> = ({ status, onSetMode }) => {
  const isConnected = status?.connected ?? false;
  const currentMode = status?.mode ?? 'WORK';

  return (
    <header className="navbar">
      <div className="nav-inner">
        <div className="brand-section">
          <div className="brand-logo">
            <Shield size={22} />
          </div>
          <div>
            <div className="brand-title">
              OpenAITunnel
              <span className="brand-badge">PRO GATEWAY</span>
            </div>
          </div>
        </div>

        <div className="nav-controls">
          {/* Outbound Tunnel Connection Pill */}
          <div className="connection-pill">
            <span className={`dot ${isConnected ? 'dot-connected' : 'dot-offline'}`} />
            <span>{isConnected ? 'TUNNEL CONNECTED' : 'CONNECTING...'}</span>
          </div>

          {/* Active Security Mode Selector */}
          <div className="mode-toggle">
            <button
              className={`mode-btn ${currentMode === 'WORK' ? 'active work' : ''}`}
              onClick={() => onSetMode('WORK')}
              title="Work Mode: Delete actions strictly intercepted, edits within workspace"
            >
              <Shield size={14} />
              WORK MODE
            </button>
            <button
              className={`mode-btn ${currentMode === 'FULL' ? 'active full' : ''}`}
              onClick={() => onSetMode('FULL')}
              title="Full Access: System-wide tools allowed, delete actions still prompted"
            >
              <ShieldAlert size={14} />
              FULL ACCESS
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
